import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Checkpoint: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 25.57 39.86">
            <path fill={color} d="M19.39,5.9l-1.34,1.52c-1.39-1.27-3.23-2.05-5.26-2.05-4.3,0-7.79,3.5-7.79,7.79s3.5,7.79,7.79,7.79,7.79-3.5,7.79-7.79c0-1.66-.52-3.2-1.41-4.47l1.49-1.68-1.26-1.12ZM18.89,13.16c0,3.37-2.74,6.11-6.11,6.11s-6.11-2.74-6.11-6.11,2.74-6.11,6.11-6.11c1.6,0,3.05.62,4.14,1.63l-4.48,5.06-2.19-2.03-1.14,1.24,3.45,3.19,5.44-6.15c.56.92.88,2,.88,3.16Z"/>
            <path fill={color} d="M12.78,0C5.73,0,0,5.73,0,12.78c0,5.52,7.71,18.79,10.81,23.91.27-.44.6-.99.99-1.63-1.13-1.89-2.7-4.57-4.25-7.46C3.71,20.46,1.68,15.34,1.68,12.78,1.68,6.66,6.66,1.68,12.78,1.68s11.1,4.98,11.1,11.1c0,2.56-2.03,7.68-5.87,14.82-1.83,3.41-3.68,6.53-4.82,8.41-.62,1.04-1.11,1.84-1.4,2.29.14.23.24.38.27.43l.71,1.13.71-1.13c.49-.78,12.07-19.19,12.07-25.95S19.83,0,12.78,0Z"/>
        </svg>
    );
};

export default Checkpoint;
